import script from "./costCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./costCategory.vue?vue&type=script&setup=true&lang=js"

import "./costCategory.vue?vue&type=style&index=0&id=8bef63d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bef63d4"]])

export default __exports__